import { render, staticRenderFns } from "./add_task.vue?vue&type=template&id=27e07423&scoped=true"
import script from "./add_task.vue?vue&type=script&lang=js"
export * from "./add_task.vue?vue&type=script&lang=js"
import style0 from "./add_task.vue?vue&type=style&index=0&id=27e07423&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e07423",
  null
  
)

export default component.exports